import Cookies from "js-cookie";

const member = {
  state: {
    userInfo: JSON.parse(window.sessionStorage.getItem("userInfo")),
  },
  mutations: {
    saveInfo: function (state, info) {
      //赋值
      state.userInfo = info;
      //写入cookie
      Cookies.set("userInfo", info);
      window.sessionStorage.setItem("userInfo", JSON.stringify(info))
    },
  },
  actions: {
    saveInfo({commit}, info) {
      commit('saveInfo', info)
    }
  }
}

export default member



// WEBPACK FOOTER //
// ./src/store/modules/member.js